import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  const scrollToContact = () => {
    document.querySelector('#contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative flex items-center bg-white overflow-hidden" data-id="element-79">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-80">
        <div className="absolute top-20 -right-20 w-[400px] sm:w-[600px] h-[400px] sm:h-[600px] bg-blue-100/30 rounded-full blur-3xl" data-id="element-81" />
      </div>

      <div className="relative w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 sm:pt-28 lg:pt-32 pb-12 sm:pb-16" data-id="element-82">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center" data-id="element-83">
          {/* Left column - Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-84">
            <h1 className="text-[28px] leading-[1.1] sm:text-4xl lg:text-5xl xl:text-6xl font-extrabold tracking-tight text-gray-900 mb-5 sm:mb-6" data-id="element-85">
              Tu obra ya se conversa por WhatsApp.
              <span className="block text-blue-600 mt-2" data-id="element-86">
                Obra Digital la transforma en eventos claros de obra.
              </span>
            </h1>

            <p className="text-base sm:text-lg lg:text-xl text-gray-600 mb-6 sm:mb-7 leading-relaxed" data-id="element-87">
              Fotos, mensajes y decisiones agrupadas automáticamente en una
              bitácora ordenada y searchable.
            </p>

            {/* Pills */}
            <div className="flex flex-wrap gap-2 sm:gap-2.5 mb-8 sm:mb-10" data-id="element-88">
              {['Sin apps nuevas', 'Eventos automáticos', 'Informes listos en minutos'].map((pill, index) => <motion.span key={pill} initial={{
              opacity: 0,
              y: 8
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.4,
              delay: 0.2 + index * 0.08
            }} className="inline-flex items-center px-3 py-1.5 rounded-full bg-blue-50 text-blue-700 text-xs sm:text-sm font-semibold border border-blue-100" data-id="element-89">
                  {pill}
                </motion.span>)}
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4" data-id="element-90">
              <button onClick={scrollToContact} className="inline-flex items-center justify-center px-6 sm:px-8 py-3.5 sm:py-4 text-sm sm:text-base font-bold text-white bg-blue-600 rounded-xl hover:bg-blue-700 active:bg-blue-800 transition-colors shadow-lg hover:shadow-xl" data-id="element-91">
                Probar con una obra real
                <ArrowRight className="ml-2 w-4 h-4 sm:w-5 sm:h-5" data-id="element-92" />
              </button>
              <a href="#" className="inline-flex items-center justify-center px-6 sm:px-8 py-3.5 sm:py-4 text-sm sm:text-base font-bold text-blue-600 bg-blue-50 rounded-xl hover:bg-blue-100 active:bg-blue-200 transition-colors" data-id="element-93">
                Ver ejemplo de informe
              </a>
            </div>
          </motion.div>

          {/* Right column - Dashboard mockup illustration */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative w-full max-w-lg mx-auto lg:max-w-none" data-id="element-94">
            {/* Browser mockup with dashboard */}
            <div className="relative bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden" data-id="element-95">
              {/* Browser chrome */}
              <div className="bg-gray-100 px-3 sm:px-4 py-2.5 sm:py-3 border-b border-gray-200 flex items-center gap-2" data-id="element-96">
                <div className="flex gap-1.5" data-id="element-97">
                  <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-red-400" data-id="element-98" />
                  <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-yellow-400" data-id="element-99" />
                  <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-green-400" data-id="element-100" />
                </div>
                <div className="flex-1 ml-2 sm:ml-4 bg-white rounded-md px-2.5 sm:px-3 py-1 text-[11px] sm:text-xs text-gray-500 truncate" data-id="element-101">
                  app.obradigital.cl
                </div>
              </div>

              {/* Dashboard content */}
              <div className="p-4 sm:p-6 bg-gradient-to-br from-gray-50 to-white" data-id="element-102">
                {/* Header */}
                <div className="mb-4 sm:mb-6" data-id="element-103">
                  <h3 className="text-base sm:text-xl font-bold text-gray-900 mb-1 leading-tight" data-id="element-104">
                    Proyecto Centro · Resumen semanal
                  </h3>
                </div>

                {/* KPI cards */}
                <div className="grid grid-cols-2 gap-2 sm:gap-3 mb-4 sm:mb-6" data-id="element-105">
                  <div className="bg-white rounded-lg p-3 sm:p-4 border border-gray-200 shadow-sm" data-id="element-106">
                    <div className="text-xl sm:text-2xl font-bold text-blue-600 mb-0.5 sm:mb-1" data-id="element-107">
                      12
                    </div>
                    <div className="text-[11px] sm:text-xs text-gray-600 font-medium" data-id="element-108">
                      Avances
                    </div>
                  </div>
                  <div className="bg-white rounded-lg p-3 sm:p-4 border border-gray-200 shadow-sm" data-id="element-109">
                    <div className="text-xl sm:text-2xl font-bold text-green-600 mb-0.5 sm:mb-1" data-id="element-110">
                      3
                    </div>
                    <div className="text-[11px] sm:text-xs text-gray-600 font-medium" data-id="element-111">
                      Decisiones
                    </div>
                  </div>
                  <div className="bg-white rounded-lg p-3 sm:p-4 border border-gray-200 shadow-sm" data-id="element-112">
                    <div className="text-xl sm:text-2xl font-bold text-amber-600 mb-0.5 sm:mb-1" data-id="element-113">
                      2
                    </div>
                    <div className="text-[11px] sm:text-xs text-gray-600 font-medium" data-id="element-114">
                      Problemas
                    </div>
                  </div>
                  <div className="bg-white rounded-lg p-3 sm:p-4 border border-gray-200 shadow-sm" data-id="element-115">
                    <div className="text-xl sm:text-2xl font-bold text-purple-600 mb-0.5 sm:mb-1" data-id="element-116">
                      5
                    </div>
                    <div className="text-[11px] sm:text-xs text-gray-600 font-medium" data-id="element-117">
                      Pendientes
                    </div>
                  </div>
                </div>

                {/* Executive summary */}
                <div className="bg-white rounded-lg p-3 sm:p-4 border border-gray-200 shadow-sm mb-3 sm:mb-4" data-id="element-118">
                  <h4 className="text-xs sm:text-sm font-bold text-gray-900 mb-1.5 sm:mb-2" data-id="element-119">
                    Resumen automático
                  </h4>
                  <p className="text-[11px] sm:text-xs text-gray-600 leading-relaxed" data-id="element-120">
                    Se avanzó en pintura interior y recepción de materiales. Hay
                    2 problemas pendientes: filtración en baño 2 y atraso en
                    instalación eléctrica.
                  </p>
                </div>

                {/* Key decisions */}
                <div className="bg-white rounded-lg p-3 sm:p-4 border border-gray-200 shadow-sm" data-id="element-121">
                  <h4 className="text-xs sm:text-sm font-bold text-gray-900 mb-2 sm:mb-3" data-id="element-122">
                    Decisiones clave
                  </h4>
                  <div className="space-y-2 sm:space-y-2.5" data-id="element-123">
                    <div className="flex items-center gap-2 sm:gap-2.5" data-id="element-124">
                      <div className="w-6 h-6 sm:w-7 sm:h-7 rounded-full bg-blue-100 flex items-center justify-center text-[10px] sm:text-xs font-bold text-blue-700 flex-shrink-0" data-id="element-125">
                        JM
                      </div>
                      <div className="flex-1 text-[11px] sm:text-xs text-gray-700" data-id="element-126">
                        Cambio de proveedor aprobado
                      </div>
                      <div className="text-[10px] text-gray-400 flex-shrink-0" data-id="element-127">
                        Mar 12
                      </div>
                    </div>
                    <div className="flex items-center gap-2 sm:gap-2.5" data-id="element-128">
                      <div className="w-6 h-6 sm:w-7 sm:h-7 rounded-full bg-green-100 flex items-center justify-center text-[10px] sm:text-xs font-bold text-green-700 flex-shrink-0" data-id="element-129">
                        PC
                      </div>
                      <div className="flex-1 text-[11px] sm:text-xs text-gray-700" data-id="element-130">
                        Inspección programada para viernes
                      </div>
                      <div className="text-[10px] text-gray-400 flex-shrink-0" data-id="element-131">
                        Mié 13
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Floating blue blur */}
            <div className="absolute -bottom-10 -right-10 w-48 sm:w-64 h-48 sm:h-64 bg-blue-400/20 rounded-full blur-3xl -z-10" data-id="element-132" />
          </motion.div>
        </div>
      </div>
    </section>;
}